import { css } from 'styled-components';

export const textSize14Mixin = css`
	font-weight: 400;
	font-size: 14px;
`;